import "./About.css"

export default function About(){

    return(

        <main>

            <div className='outerBox'>
                <h1>About</h1>

                <div className="innerBox">
                    <div>  Created by: Jonathan Piltz  </div>
                    <div>Last Updated: June 30, 2025</div>
                </div>
            </div>
            
        </main>

    )

}